import moment from "moment";
import i18n from "@/i18n";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      { component: "search-disaster-types", label: "재해형태", value: "disaster", query: { dty: "disaster" }, options: {} },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["재해형태", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({ key: "body.riskList[%].input4", operator: "LIKE", value: `%${search.disaster}%` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "회사명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "공정명",
        key: "body.stdInfo.공정명",
      },
      {
        name: "재해형태",
        key: "body.riskList[%].input4",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 회사명
        case 1:
          return func.getContent(value).stdInfo.공정명; // 공정명
        case 2: {
          const riskList = func.getContent(value).riskList;
          if (riskList.length > 0) {
            // 각 항목에서 '직접입력_' 접두어 제거 처리
            const processedItems = riskList
              .map((e) => {
                const item = e.input4 || "";
                // '직접입력_'으로 시작하면 접두어 제거하고 반환
                if (item.startsWith("직접입력_")) {
                  return item.substring("직접입력_".length);
                }
                return i18n.t(item);
              })
              .filter(Boolean); // 빈 문자열 제거

            // 중복 제거 (Set 활용)
            const uniqueItems = [...new Set(processedItems)];

            return uniqueItems.join(", ");
          }
          // return func.getContent(value).riskList[0].input4; // 재해형태
        }
        // return func.getContent(value).riskDisaster; // 재해형태
        case 3:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 4:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
